import Store from '@/store'
import router from '@/router'

const guest = (to, from, next) => {
  if (!Store.state.auth.isAuthenticated) {
    next()
  } else {
    router.replace({ name: 'home' })
  }
}

export default guest
